/* eslint-disable react/no-string-refs */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Html from 'Component/Html';
import NewsletterSubscription from 'Component/NewsletterSubscription';
import Popup from 'Component/Popup';
import YBFormWebForm from 'Component/YBFormWebForm';
import YBPopupBuilderQuery from 'Query/YBPopupBuilder.query';
import { noopFn } from 'Util/Common';
import {
    fetchMutation
} from 'Util/Request';

import './YBPopupBuilder.style';

/** @namespace Elganso/Component/YBPopupBuilder/Component */
export class YBPopupBuilderComponent extends PureComponent {
    static propTypes = {
        onClick: PropTypes.func
    };

    static defaultProps = {
        onClick: noopFn
    };

    state = {
        maxClick: true
    };

    clickPopUpReport = this.clickPopUpReport.bind(this);

    renderPopupNewsletter() {
        return (
            <Popup
              id="popupbuilder"
              clickOutside={ false }
              mix={ { block: 'YBPopupBuilder', elem: 'Popup' } }
            >
                <NewsletterSubscription key="NewsletterSubscription" blockPopupConditionsPopup />
            </Popup>
        );
    }

    renderPopupWebForm(form_id) {
        const {
            id,
            html
        } = this.props;

        if (!form_id) {
            return null;
        }

        const prueba = html.replace(/<script[^>]*>(?:(?!<\/script>)[^])*<\/script>/g, '');

        return (
            <Popup
              id="popupbuilder"
              clickOutside={ false }
              mix={ { block: 'YBPopupBuilder', elem: 'Popup' } }
              ref="popupBuilder"
              idBuilder={ id }
            >
                <div>
                    <Html content={ prueba } />
                    <YBFormWebForm
                      form_id={ form_id }
                    />
                </div>
            </Popup>
        );
    }

    renderPopupBuilderWidgetForm(widget) {
        if (widget.type === 'magento_widget') {
            return this.renderPopupWebForm(widget.form_id);
        } if (widget.type === 'newsletter_form') {
            return this.renderPopupNewsletter();
        }

        return null;
    }

    async _createPopupBuilderReportData(id, type) {
        const mutationPopUpReport = YBPopupBuilderQuery.createPopupReport(id, type);
        await fetchMutation(mutationPopUpReport);
    }

    clickPopUpReport() {
        const { onClick, id } = this.props;
        const { maxClick } = this.state;
        if (maxClick) {
            this._createPopupBuilderReportData(id, 'click');
        }
        this.setState({
            maxClick: false
        });

        onClick();
    }

    renderPopupBuilder() {
        const {
            id,
            html,
            widget
        } = this.props;
        const { maxClick } = this.state;

        if (id !== '' && maxClick) {
            this._createPopupBuilderReportData(id, 'open');
        }

        if (widget.length > 2) {
            const widgets = JSON.parse(widget);
            return widgets.map(this.renderPopupBuilderWidgetForm.bind(this));
        }

        return (
            <Popup
              id="popupbuilder"
              clickOutside={ false }
              mix={ { block: 'YBPopupBuilder', elem: 'Popup' } }
              idBuilder={ id }
            >
                <botton onClick={ this.clickPopUpReport }>
                    <Html content={ html } />
                </botton>
            </Popup>
        );
    }

    render() {
        return (
            <div block="YBPopupBuilder">
                { this.renderPopupBuilder() }
            </div>
        );
    }
}

export default YBPopupBuilderComponent;
